// import {get, post, qspost, put, deletefn} from '@/api/axios'
import {post} from '@/plugins/axios'

/*
 * 登录
 * @constructor jack
 * */
export const login = (phone, pass, code) => post('/admin/login', {phone, pass, code})

/*
 * 发送短信验证码
 * @constructor jack
 * */

/*
 * 修改密码
 * @constructor jack
 * */

/*
 * 获取当前用户的项目及项目子系统
 * @constructor jack
 * */
export const getChances = (u_token) => post('/admin/getChances', {u_token})


/*
* 获取用户要进入某个角色的token及菜单
* @constructor jack
* */
export const orgLogin = (token,item_id,org_id,org_type) => post('/admin/orgLogin', {token,item_id,org_id,org_type})
